import { window } from "@gr-common/body/namespaces";
export * from "../lib/nexus/index.js";
export * from "../lib/nexus/function/public.js";
export * from "../lib/nexus/event/public.js";
export * from "../lib/nexus/namespace/public.js";
const forServer = () => createProxy(createStore(name)[1], configAsync);
const otto = import.meta.env.SSR ? forServer() : window.otto ?? {};
export {
  otto
};
